import React from "react";

const Team = ({ data }) => {
    if (!data || !Array.isArray(data)) return null;

    const renderMembers = (members) => (
        <div className="row justify-content-center">
            {members.map((member, index) => (
                <div className="col-md-4 col-12 mb-3" key={index}>
                    <div className="single-faculty-item text-center">
                        <img
                            src={member.image}
                            alt={member.name}
                            className="img-fluid facluty-main-image"
                            loading="lazy"
                            decoding="async"
                            onError={(e) => {
                                e.target.src = "https://via.placeholder.com/150x150?text=No+Image";
                            }}
                            style={{ borderRadius: '10px', width: '220px', height: '220px', objectFit: 'cover' }}
                        />
                        <h4 className="faculty-title mt-3">{member.name}</h4>
                        <p className="faculty-designation">{member.designation}</p>
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <section className="faculty_section " id="faculty">
            <div className="container">
                <div className="sec-title text-center">
                    <h2>Team</h2>
                </div>

                <div className="accordion" id="accordionfaculty">
                    {data.map((teamGroup, index) => (
                        <div className="accordion-item mb-3" key={index}>
                            <h2 className="accordion-header" id={`heading${index}`}>
                                <button
                                    className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse${index}`}
                                    aria-expanded={index === 0}
                                    aria-controls={`collapse${index}`}
                                >
                                    {teamGroup.heading}
                                </button>
                            </h2>
                            <div
                                id={`collapse${index}`}
                                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                aria-labelledby={`heading${index}`}
                                data-bs-parent="#accordionfaculty"
                            >
                                <div className="accordion-body">
                                    {renderMembers(teamGroup.members)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Team;